var map = {
	"./big-gallery-1.jpg": 65266,
	"./big-gallery-2.jpg": 37583,
	"./big-gallery-3.jpg": 46776,
	"./carousel-md-1.jpg": 91330,
	"./carousel-md-2.jpg": 22904,
	"./carousel-md-3.jpg": 99256,
	"./carousel-md-4.jpg": 92430,
	"./cat2-md-1.jpg": 79174,
	"./cat2-md-2.jpg": 72158,
	"./cat2-md-3.jpg": 54630,
	"./cat2-md-4.jpg": 4267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29301;